import React, { Component } from 'react';
import FileDrop from 'react-file-drop';
import './FileDropper.css';

class FileDropper extends Component {
  constructor(props) {
    super(props);
    this._handleFileDrop = (files,events) => {
      this.handleFileDrop(files,events);
    };
    this.fr = new FileReader();
    this.fr.onerror = (err) => {
      console.error('File Reader error', err);
    };

    this.fr.onloadend = () => {
      // console.log('File Read', this.props);
      props.onload(this.fr.result);
    };

  }
  handleFileDrop(files, event) {
    // console.log(files);

    if (files.length > 0) {
      // console.log('reading file', files[0], this.fr);
      this.fr.readAsArrayBuffer(files[0])
    }
  }
  render() {
    return (
      <div className="my-uploader">
        <FileDrop frame={document} onDrop={this._handleFileDrop} targetAlwaysVisible={true}>
          Drop a MIDI File here to use its chords.
        </FileDrop>
      </div>
    );
  }
}

export default FileDropper;


// WEBPACK FOOTER //
// ./src/FileDropper.js